module.exports = __webpack_public_path__ + "img/logo.7708c321.png";